export default {
      id: "career-start-usage",
      viewBox: "0 0 122 102",
      url: __webpack_public_path__ + "sprite.svg#career-start",
      toString: function () {
        return this.url;
      }
    }